export const AUTH_STRINGS = {
  'register.title': 'Become a <span>Belong Member!</span>',
  'register.non_invasive.title': 'Sign Up To <span>See Times</span>!',
};
